import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import compose from 'ramda/src/compose';
import { UserSession } from 'ascendon-web-toolkit/utils';
import { postMessage } from '../utils/postMessage';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function SignOut() {
  const history = useHistory();
  const clientSettings = useSelector((state) => state.ascendon.settings);

  useEffect(() => {
    UserSession.remove();
    postMessage('session.expired', clientSettings);
    history.push('/signIn');
  }, []);

  return <></>;
}

export default compose(withTranslation())(SignOut);
